<template>
    <div class="price">
        <div class="open-wrapper pointer" @click="openModal">
            <slot>
                <a href="javascript://void(0)">Open</a>
            </slot>
        </div>

        <modal :name=modalId
               :adaptive="true"
               :scrollable="true"
               @before-close="beforeClose"
               height="auto">
            <div class="dashboard-block" :class="{loading: loading}">
                <header>
                    <h4 v-if="model.created_at" class="display-block">
                        <span v-html="model.displayAmount"></span>
                        <span v-html="model.archivedLabel"></span>
                    </h4>
                    <h4 v-else>Create Price</h4>
                    <h5 v-if="model.created_at">Price</h5>
                </header>

                <form @submit.prevent="saveModel" accept-charset="UTF-8" novalidate="novalidate"
                      data-vv-scope="price">
                    <fieldset>
                        <legend>Price</legend>

                        <div class="row">
                            <div class="col-xs-12 col-sm-4 form-group has-feedback"
                                 :class="{'has-error': errors.has('price.Price[amount]')}">
                                <label for="price-amount">Resident Charge</label>

                                <div class="input-group">
                                    <span class="input-group-addon">$</span>

                                    <input id="price-amount"
                                           name="Price[amount]"
                                           type="number"
                                           placeholder="0.00"
                                           class="form-control"
                                           v-model="model.amount"
                                           v-validate="'required'">
                                </div>

                                <span v-show="errors.has('price.Price[amount]')" class="help-block">
                                    {{ errors.first('price.Price[amount]') }}
                                </span>
                            </div>

                            <div class="col-xs-6 col-sm-4 form-group has-feedback"
                                 :class="{'has-error': errors.has('price.Price[start_at]')}">
                                <label for="price-start-at">Move In</label>

                                <input id="price-start-at"
                                       name="Price[start_at]"
                                       type="date"
                                       class="form-control"
                                       v-model="model.start_at"
                                       v-validate="'required'">

                                <span v-show="errors.has('price.Price[start_at]')" class="help-block">
                                    {{ errors.first('price.Price[start_at]') }}
                                </span>
                            </div>

                            <div class="col-xs-6 col-sm-4 form-group has-feedback"
                                 :class="{'has-error': errors.has('price.Price[lease_renewal_notification_at]')}">
                                <label for="price-lease-renewal-notification-at">Lease Renewal &nbsp;</label><i class="fa fa-info-circle text-gray tool-tip"><span class="tool-tip-text">The date in which this price was included for lease renewals. Leave empty if this date is unknown.</span></i>

                                <input id="price-lease-renewal-notification-at"
                                       name="Price[lease_renewal_notification_at]"
                                       type="date"
                                       v-model="model.lease_renewal_notification_at"
                                       class="form-control">

                                <span v-show="errors.has('price.Price[lease_renewal_notification_at]')" class="help-block">
                                    {{ errors.first('price.Price[lease_renewal_notification_at]') }}
                                </span>
                            </div>
                        </div>

                        <legend>Owner Rates</legend>
                        <div class="row">
                            <div class="col-xs-12 col-sm-4 form-group has-feedback"
                                 :class="{'has-error': errors.has('price.Price[onboard_rate]')}">
                                <label for="price-onboard-rate">Onboard Rate</label>

                                <div class="input-group">
                                    <span class="input-group-addon">$</span>

                                    <input id="price-onboard-rate"
                                           name="Price[onboard_rate]"
                                           type="number"
                                           placeholder="0.00"
                                           class="form-control"
                                           v-model="model.onboard_rate"
                                           v-validate="'required'">
                                </div>

                                <span v-show="errors.has('price.Price[onboard_rate]')" class="help-block">
                                    {{ errors.first('price.Price[onboard_rate]') }}
                                </span>
                            </div>
                            <div class="col-xs-12 col-sm-4 form-group has-feedback"
                                 :class="{'has-error': errors.has('price.Price[provider_rate]')}">
                                <label for="price-provider-rate">Provider Rate</label>

                                <div class="input-group">
                                    <span class="input-group-addon">$</span>

                                    <input id="price-provider-rate"
                                           name="Price[provider_rate]"
                                           type="number"
                                           placeholder="0.00"
                                           class="form-control"
                                           v-model="model.provider_rate"
                                           v-validate="'required'">
                                </div>

                                <span v-show="errors.has('price.Price[provider_rate]')" class="help-block">
                                    {{ errors.first('price.Price[provider_rate]') }}
                                </span>
                            </div>
                            <div class="col-xs-12 col-sm-4 form-group has-feedback"
                                 :class="{'has-error': errors.has('price.Price[marketing_fee_rate]')}">
                                <label for="price-marketing-fee-rate">Marketing Fee Rate</label>

                                <div class="input-group">
                                    <span class="input-group-addon">$</span>

                                    <input id="price-marketing-fee-rate"
                                           name="Price[marketing_fee_rate]"
                                           type="number"
                                           placeholder="0.00"
                                           class="form-control"
                                           v-model="model.marketing_fee_rate"
                                           v-validate="'required'">
                                </div>

                                <span v-show="errors.has('price.Price[marketing_fee_rate]')" class="help-block">
                                    {{ errors.first('price.Price[marketing_fee_rate]') }}
                                </span>
                            </div>
                            <div class="col-xs-12 col-sm-4 form-group has-feedback"
                                 :class="{'has-error': errors.has('price.Price[tax_rate]')}">
                                <label for="price-tax-rate">Tax Rate</label>

                                <div class="input-group">
                                    <span class="input-group-addon">$</span>

                                    <input id="price-tax-rate"
                                           name="Price[tax_rate]"
                                           type="number"
                                           placeholder="0.00"
                                           class="form-control"
                                           v-model="model.tax_rate"
                                           v-validate="'required'">
                                </div>

                                <span v-show="errors.has('price.Price[tax_rate]')" class="help-block">
                                    {{ errors.first('price.Price[tax_rate]') }}
                                </span>
                            </div>
                        </div>
                        <hr>

                        <div class="row">
                            <div class="col-xs-6 form-group">
                                <button type="button" class="btn btn-sm btn-warning"
                                        v-if="model.created_at"
                                        @click="deleteModel"
                                        :disabled="loading">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                </button>
                            </div>

                            <div class="col-xs-6 form-group pull-right">
                                <button type="submit" class="btn btn-success btn-block" :disabled="loading">
                                    Save
                                </button>
                            </div>
                        </div>
                    </fieldset>
                </form>
            </div>
        </modal>
    </div>
</template>

<script>
    import model from "./mixins/model";

    export default {
        mixins: [ model ],

        props: {
            projectId: {
                type: String,
                default: null
            },
        },

        computed: {
            url(){
                if( this.model.id ){
                    return '/api/prices/' + this.model.id;
                }
                else {
                    return '/api/prices';
                }
            },

            saveValidationKey(){
                return 'price'
            },

            resourceKey(){
                return 'Price';
            },
        },

        methods: {
            beforeSave(){
                this.model.amount_cents = Math.round(parseFloat(this.model.amount) * 100);
                this.model.onboard_rate_amount_cents = Math.round(parseFloat(this.model.onboard_rate) * 100);
                this.model.provider_rate_amount_cents = Math.round(parseFloat(this.model.provider_rate) * 100);
                this.model.tax_rate_amount_cents = Math.round(parseFloat(this.model.tax_rate) * 100);
                this.model.marketing_fee_rate_amount_cents = Math.round(parseFloat(this.model.marketing_fee_rate) * 100);
                if( !this.model.created_at ){
                    this.model.project_id = this.projectId;
                }
            },
        }
    }
</script>
